// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"2461e77c","453":"6933ba0b"}[chunkId] + ".chunk.js";
};